import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { AppDispatch } from '@/store'

import type * as Types from './types'
import { getPlatformList } from '@/services/api'

const initialState: Types.IInitialState = {
  platformList: [],
  syncStockRules: null,
}

const stockSlice = createSlice({
  name: 'order',
  initialState: initialState,
  reducers: {
    /** 获取支持上传库存的销售平台列表 */
    setPlatformList(state, action: PayloadAction<string[]>) {
      return {
        ...state,
        platformList: action.payload,
      }
    },
    /**
     * 设置同步库存的规则
     * 入口： 库存管理 -> 手动库存同步
     * */
    setSyncStockRules(state, action: PayloadAction<Types.ISyncStockRules>) {
      return {
        ...state,
        syncStockRules: action.payload,
      }
    },
  },
})

export const { setPlatformList, setSyncStockRules } = stockSlice.actions

/** 获取支持平台库存的平台 */
export const getBindPlatformList = () => async (dispatch: AppDispatch) => {
  const resp = await getPlatformList()
  dispatch(setPlatformList(resp?.data?.list))
}

export default stockSlice.reducer
